module.exports = {
    profile: {
        en: "Profile",
        fi: "profiili"
    },
    name: {
        en: "Name",
        fi: "Nimi"
    },
    nameToolTip: {
        en: "Name is required",
        fi: "Nimi on pakollinen"
    },
    email: {
        en: "Email",
        fi: "Sähköposti"
    },
    emailToolTip: {
        en: "Email is required",
        fi: "Sähköposti on pakollinen"
    },
    selectARole: {
        en: "Select a role",
        fi: "Valitse rooli"
    },
    individual: {
        en: "Individual",
        fi: "Yksilö"
    },
    store: {
        en: "Store",
        fi: "Yritys"
    },
    selectARoleToolTip: {
        en: "Role is required",
        fi: "Rooli on pakollinen"
    },
    phone: {
        en: "Phone",
        fi: "Puhelin"
    },
    phoneToolTip: {
        en: "Phone is required",
        fi: "Puhelinnumero on pakollinen"
    },
    selectAProvince: {
        en: "Select a province",
        fi: "Valitse maakunta"
    },
    selectAProvinceToolTip: {
        en: "Province is required",
        fi: "Maakunta on pakollinen"
    },
    selectACity: {
        en: "Select a city",
        fi: "Valitse kaupunki"
    },
    selectACityToolTip: {
        en: "City is required",
        fi: "Kaupunki on pakollinen"
    },
    address: {
        en: "Address",
        fi: "Osoite"
    },
    addressToolTip: {
        en: "Address is required",
        fi: "Osoite on pakollinen"
    },
    website: {
        en: "Website",
        fi: "Kotisivu"
    },
    websiteToolTip: {
        en: "Website is optional",
        fi: "Kotisivu on valinnainen"
    },
    addMoreContacts: {
        en: "Add more contacts",
        fi: "Lisää yhteystieto"
    },
    selectLanguages: {
        en: "Select languages",
        fi: "Valitse kielet"
    },
    edit: {
        en: "Edit",
        fi: "Muokkaa"
    },
    cancel: {
        en: "Cancel",
        fi: "Peruuta"
    },
    save: {
        en: "Save",
        fi: "Tallenna"
    },
    changePassword: {
        en: "Change password",
        fi: "Vaihda salasana"
    },
    currentPassword: {
        en: "Current password",
        fi: "Nykyinen salasana"
    },
    currentPasswordToolTip: {
        en: "Current password is required and must be greater than 7 characters",
        fi: "Salasana on pakollinen ja sen tulee olla yli 7 merkkiä pitkä"
    },
    newPassword: {
        en: "New password",
        fi: "Uusi salasana"
    },
    newPasswordToolTip: {
        en: "New Password is required and must be greater than 7 characters",
        fi: "Salasanan on pakko vastata yllä olevaa"
    },
    confirmNewPassword: {
        en: "Confirm new password",
        fi: "Vahvista uusi salasana"
    },
    confirmNewPasswordToolTip: {
        en: "Confirm New password is required and must match above New Password",
        fi: "Salasanan on pakko vastata yllä olevaa"
    },
    change: {
        en: "Change",
        fi: "Muuta"
    }
};